<p style="padding: 10px 20px 0 20px;">{{'not-found-text' | translate}}</p>